<template>
<v-col xs="12">
  <v-text-field solo flat persistent-hint :hint="$t('Nové heslo')" id="password1" v-model="newValue" type="password" :rules="newRules" required :disabled="error"></v-text-field>
  <v-text-field solo flat persistent-hint :hint="$t('Potvrzení hesla')" id="password2" v-model="inputValue" type="password" :disabled="!canConfirm(newValue) || error" :rules="confirmRules" required :error="error" :error-messages="$t(errorMessage)">
  </v-text-field>
</v-col>
</template>
<script>
import TransformMixin from '../mixins/transform-mixin.js'
export default {
  name: 'setting-password',
  props: {
    value: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  mixins: [TransformMixin],
  data() {
    return {
      newValue: null,
      newRules: [
        (v) => this.canConfirm(v) || this.transform('Heslo musí mít alespoň 8 znaků')
      ],
      confirmRules: [
        (v) => this.hasConfirmed(v) || this.transform('Heslo musí být stejné'),
        () => !this.error || this.transform(this.errorMessage)
      ]
    }
  },
  computed: {
    error: {
      get() {
        return this.errorMessage !== null
      }
    },
    inputValue: {
      get() {
        return this.value ? this.value : null
      },
      set(value) {
        if (this.hasConfirmed(value)) {
          this.$emit('input', value)
        }
      }
    }
  },
  methods: {
    canConfirm(value) {
      return !!value && value.length >= 8
    },
    hasConfirmed(value) {
      return this.newValue !== null && this.newValue === value
    }
    //   onChange(value) {
    //     this.$emit('input', value)
    //   }
  },
  created() {
    this.newValue = null
    this.inputValue = null
  }
}
</script>
<style>
</style>
